export const sampleRate = (timestampsMs: number[]) => {
    if (timestampsMs.length < 2) return 0
    const durationSeconds = (timestampsMs[timestampsMs.length - 1] - timestampsMs[0]) / 1000
    return durationSeconds > 0 ? (timestampsMs.length - 1) / durationSeconds : 0
}
